import { adExposureCount } from '../api/ad360'
function createOb(el, binding) {
	const ob = new IntersectionObserver(entries => {
		if (entries[0].intersectionRatio >= 0.3) {
			// TODO 触发回调
			const w = Math.round(el.getBoundingClientRect().width)
			const h = Math.round(el.getBoundingClientRect().height)
			// console.log('触发了', binding.value, top, window.scrollY, el)
			adExposureCount(w, h, binding.value.imptk)
			ob.unobserve(el)
		}
	},
	{
		root: null,
		threshold: [0.3],
	})
	return function () {
		setTimeout(() => {
			ob.observe(el)
		}, 200)
	}
}

export default {
	inserted(el, binding) {
		if (!IntersectionObserver) return
		el.observer = createOb(el, binding)()
	},
}
